import React from 'react';
import { Grid, Tooltip, Typography, withStyles } from 'material-ui';
import { DatePicker } from 'material-ui-pickers';
import EventIcon from 'material-ui-icons/Event';
import LeftArrowIcon from 'material-ui-icons/ArrowBack';
import RightArrowIcon from 'material-ui-icons/ArrowForward';
import UpdateIcon from 'material-ui-icons/Update';

import TextField from 'material-ui/TextField/TextField';
import { MenuItem } from 'material-ui/Menu/index';
import moment from 'moment';
import { translate } from 'react-i18next';

import {
    handlecheckInChangeFactory,
    handlecheckOutChangeFactory,
    handleNightsChangeFactory,
} from '../../Utils/FilterChangeFunctions';

import { isEdge } from '../../../services/browserDetector';

const styles = theme => ({
    title: {
        fontWeight: 700,
        fontSize: '16px'
    },
    inputLabel: {
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        color: 'var(--primary-color)',
    },
    updateIcon: {
        color: 'var(--primary-color)'
    },
    calendarIcon: {
        color: 'var(--primary-color)',
        marginRight: '-24px'
    },
    calendarIconIE: {
        color: 'var(--primary-color)',
        marginTop: '-20px',
        paddingBottom: '5px'
    },
});

class ModifyDatesView extends React.Component {

    constructor(props) {
        super(props);

        this.START_DAY = new Date();
        this.MAX_NIGHTS = process.env.REACT_APP_SEARCH_MAX_NIGHTS;
        this.ADD_NIGHTS = false;
        this.state = this.initState(props.reservation);
    }

    initState(reservation) {
        let checkin = reservation ? moment(reservation.checkIn, 'DD/MM/YYYY') : moment(new Date(), 'DD/MM/YYYY');
        let checkout = reservation ? moment(reservation.checkOut, 'DD/MM/YYYY') : moment(new Date(), 'DD/MM/YYYY');
        return {
            loading: false,
            checkIn: checkin,
            checkOut: checkout,
            nights: this.calculateNights(checkin, checkout),
            reservation: reservation,
            showModifiedIcon: false
        };
    }

    /**
     * Returns the number of nights of a reservation
     *
     * @param {String} arrivalString arrival Date as string. Format "DD/MM/YYYY"
     * @param {String} departureString departure Date as string. Format "DD/MM/YYYY"
     * @returns {Int} number of nights of a reservation
     */
    calculateNights(arrivalString, departureString) {
        let arrival = moment(arrivalString, 'DD/MM/YYYY');
        let departure = moment(departureString, 'DD/MM/YYYY');

        return moment.duration(departure.diff(arrival)).as('days');
    }

    onArrivalChange = date => {
        const handleArrivalChange = handlecheckInChangeFactory(this);
        handleArrivalChange(date);
        this.setState({ showModifiedIcon: true });
        this.props.setDateFilters(date, 1);
    };

    onDepartureChange = date => {
        const handleDepartureChange = handlecheckOutChangeFactory(this);
        let diff = handleDepartureChange(date);
        this.setState({ showModifiedIcon: true });
        this.props.setDateFilters(this.state.checkOut, diff);
    };

    onNightsChange = event => {
        const handleChangeNights = handleNightsChangeFactory(this);
        handleChangeNights(event);
        this.setState({ showModifiedIcon: true });
        this.props.setDateFilters(this.state.checkIn, event.target.value);
    };

    render() {
        const { reservation, classes, t } = this.props;
        const totalNightsArray = [...Array(30 + 1).keys()].slice(1);

        return (
            <Grid container spacing={8} className="formContainer">
                <Grid item xs={12}>
                    <Typography className={classes.title}>{this.props.title}</Typography>
                </Grid>
                <Grid item xs={12}
                    container
                    direction="row">
                    <Grid item xs={1} className={classes.changeTooltipContainer}>
                        {reservation && this.state.showModifiedIcon ?
                            <Tooltip
                                title={t('MODIFY_BOOKING.MODIFIED_DATE')}
                                enterDelay={200}>
                                <UpdateIcon className={classes.updateIcon} />
                            </Tooltip>
                            : ''
                        }
                    </Grid>
                    <Grid item xs={4}>
                        <DatePicker
                            value={this.state.checkIn}
                            onChange={this.onArrivalChange}
                            label={t('COMMON.CHECK_IN')}
                            keyboard
                            style={{
                                width: '100%'
                            }}
                            format={'DD/MM/YYYY'}
                            disabled={this.state.loading}
                            autoOk
                            leftArrowIcon={<LeftArrowIcon />}
                            rightArrowIcon={<RightArrowIcon />}
                            InputLabelProps={{
                                className: classes.inputLabel,
                            }}
                            disablePast
                            keyboardIcon={
                                <EventIcon
                                    className={isEdge() ? classes.calendarIconIE : classes.calendarIcon}
                                />
                            }
                            animateYearScrolling={false}
                            className={'datePickerResults'}
                            minDateMessage={t('HOME.DATE_VALIDATION')}
                            invalidDateMessage={t('HOME.INVALID_FORMAT')}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        <TextField
                            select
                            label={t('COMMON.NIGHTS')}
                            value={this.state.nights}
                            style={{
                                width: '100%'
                            }}
                            onChange={this.onNightsChange}
                            SelectProps={{ MenuProps: { className: classes.menu } }}
                            InputLabelProps={{
                                className: classes.inputLabel,
                            }}
                            InputProps={{
                                classes: {
                                    input: classes.disabledTextFieldInput,
                                },
                            }}
                            disabled={this.state.loading}>
                            {totalNightsArray.map((option, ix) => (
                                <MenuItem key={ix} value={Number.parseInt(option)}>
                                    {option}
                                </MenuItem>
                            ))}
                        </TextField>
                    </Grid>
                    <Grid item xs={4}>
                        <DatePicker
                            value={this.state.checkOut}
                            onChange={this.onDepartureChange}
                            label={t('COMMON.CHECK_OUT')}
                            keyboard
                            format={'DD/MM/YYYY'}
                            autoOk
                            style={{
                                width: '100%'
                            }}
                            InputLabelProps={{
                                className: classes.inputLabel,
                            }}
                            leftArrowIcon={<LeftArrowIcon />}
                            rightArrowIcon={<RightArrowIcon />}
                            disablePast
                            keyboardIcon={
                                <EventIcon
                                    className={isEdge() ? classes.calendarIconIE : classes.calendarIcon}
                                />
                            }
                            animateYearScrolling={false}
                            className={'datePickerResults'}
                            disabled={this.state.loading}
                            minDateMessage={t('HOME.DATE_VALIDATION')}
                            invalidDateMessage={t('HOME.INVALID_FORMAT')}
                        />
                    </Grid>
                </Grid>
            </Grid>
        );
    }
}

export default translate('translations')(withStyles(styles)(ModifyDatesView));



// WEBPACK FOOTER //
// ./src/components/Reservation/Modification/ModifyDatesView.js